<div class="premium-viewer-wrapper full-screen" [class.is-cropping-active]="isCroppingMode" (click)="dismiss()">

  <!-- 1. Normal View Floating Header (Solo cuando NO se está en modo edición/recorte) -->
  <div class="viewer-header-floating" *ngIf="!isCroppingMode">
    <div class="title-section">
      <ion-icon name="image-outline"></ion-icon>
      <div class="title-info">
        <span class="main-title">{{ currentImage?.texto || 'Vista Previa' }}</span>
        <span class="image-counter" *ngIf="images.length > 1">{{ currentIndex + 1 }} de {{ images.length }}</span>
      </div>
    </div>

    <div class="header-actions-float">
      <!-- Crop button -->
      <ion-button fill="clear" class="crop-btn-float" *ngIf="enableCrop && currentImage && !currentImage.path?.toLowerCase()?.endsWith('.pdf')" (click)="startCropping($event)" title="Recortar">
        <ion-icon name="crop-outline"></ion-icon>
      </ion-button>
      
      <ion-button fill="clear" class="close-btn-float" (click)="dismiss()">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </div>
  </div>

  <!-- 2. Header Exclusivo de Edición/Recorte (No interfiere con los puntos de las esquinas) -->
  <div class="crop-header-bar" *ngIf="isCroppingMode" (click)="$event.stopPropagation()">
    <ion-button fill="clear" class="crop-header-btn" (click)="cancelCropping($event)" title="Cancelar edición">
      <ion-icon name="close-outline" slot="icon-only"></ion-icon>
    </ion-button>

    <div class="crop-header-info">
      <span class="crop-header-title">Ajustar Esquinas</span>
      <span class="crop-header-sub">Arrastra los círculos azules para recortar</span>
    </div>

    <div class="crop-header-placeholder"></div>
  </div>

  <!-- 3. Stage Principal de Imagen / Canvas -->
  <div class="image-stage" (click)="$event.stopPropagation()">
    <!-- Navigation Buttons -->
    <ion-button *ngIf="images.length > 1 && currentIndex > 0 && !isCroppingMode" fill="clear" class="nav-btn prev" (click)="prev($event)">
      <ion-icon name="chevron-back-outline"></ion-icon>
    </ion-button>

    <div class="img-wrapper"
         [class.cropping-view]="isCroppingMode"
         (touchstart)="isCroppingMode ? null : onTouchStart($event)"
         (touchmove)="isCroppingMode ? null : onTouchMove($event)"
         (touchend)="isCroppingMode ? null : onTouchEnd($event)">
      <!-- Loading Spinner -->
      <div *ngIf="isImageLoading && !isCroppingMode" class="loading-container-float animate__animated animate__fadeIn">
        <ion-spinner name="crescent" color="primary"></ion-spinner>
        <span class="loading-text">Cargando...</span>
      </div>

      <!-- Crop Canvas element -->
      <canvas #cropCanvas class="crop-canvas" *ngIf="isCroppingMode"></canvas>

      <ng-container *ngIf="currentImage && !isCroppingMode">
        <!-- New Flow (Gallery with pipes) -->
        <img *ngIf="currentImage.source !== 'legacy'" 
             [src]="currentImage.path | imageAuth:getImagePath(currentImage.source) | async" 
             (load)="isImageLoading = false"
             [style.opacity]="isImageLoading ? '0' : '1'"
             [style.transform]="'scale(' + zoomScale + ') translate(' + panX + 'px, ' + panY + 'px)'"
             class="main-image animate__animated animate__zoomIn" />
        
        <!-- Legacy Flow (Already resolved dataURI or URL) -->
        <img *ngIf="currentImage.source === 'legacy'" 
             [src]="currentImage.path" 
             (load)="isImageLoading = false"
             [style.opacity]="isImageLoading ? '0' : '1'"
             [style.transform]="'scale(' + zoomScale + ') translate(' + panX + 'px, ' + panY + 'px)'"
             class="main-image animate__animated animate__zoomIn" />
      </ng-container>

      <div *ngIf="!currentImage && !isCroppingMode" class="empty-state">
        <ion-icon name="alert-circle-outline"></ion-icon>
        <p>No se pudo cargar la imagen</p>
      </div>
    </div>

    <ion-button *ngIf="images.length > 1 && currentIndex < images.length - 1 && !isCroppingMode" fill="clear" class="nav-btn next" (click)="next($event)">
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>

  <!-- Normal Zoom Footer (Solo cuando NO se está en modo recorte) -->
  <div class="viewer-footer-floating animate__animated animate__fadeInUp" *ngIf="!isCroppingMode" (click)="$event.stopPropagation()">
    <div class="zoom-controls">
      <ion-button fill="clear" class="zoom-btn" (click)="zoomOut($event)" [disabled]="zoomScale <= 1">
        <ion-icon name="remove-circle-outline"></ion-icon>
      </ion-button>
      <span class="zoom-level">{{ (zoomScale * 100).toFixed(0) }}%</span>
      <ion-button fill="clear" class="zoom-btn" (click)="zoomIn($event)" [disabled]="zoomScale >= 3">
        <ion-icon name="add-circle-outline"></ion-icon>
      </ion-button>
      <ion-button fill="clear" class="zoom-btn reset" (click)="resetZoom($event)" *ngIf="zoomScale !== 1">
        <ion-icon name="refresh-outline"></ion-icon>
      </ion-button>
    </div>
  </div>

  <!-- Crop Actions Footer (Diseño estilo escáner nativo en edición) -->
  <div class="viewer-footer-floating crop-actions-footer animate__animated animate__fadeInUp" *ngIf="isCroppingMode" (click)="$event.stopPropagation()">
    
    <!-- Fila 1: Botones de utilidades / ajustes rápidos -->
    <div class="crop-utilities-row">
      <ion-button fill="clear" class="crop-util-btn" (click)="detectDocumentEdges()">
        <ion-icon name="scan-outline" slot="start" class="util-icon scan-icon"></ion-icon>
        Recortar automáticamente
      </ion-button>

      <ion-button fill="clear" class="crop-util-btn" (click)="resetToFullFrame()">
        <ion-icon name="contract-outline" slot="start" class="util-icon reset-icon"></ion-icon>
        No recortar
      </ion-button>

      <ion-button fill="clear" class="crop-util-btn icon-only-btn" (click)="rotate()">
        <ion-icon name="refresh-outline" slot="icon-only" class="util-icon rotate-icon"></ion-icon>
      </ion-button>
    </div>

    <!-- Fila 2: Botón principal Aplicar -->
    <div class="crop-main-apply-row">
      <ion-button expand="block" class="apply-scan-btn" (click)="confirmCropping()">
        Aplicar
      </ion-button>
    </div>

  </div>
</div>
